<template>
	<div style="height: 84vh;">
		<ListingButton :lists="lists" @add='add' @delete='BatchDelete'></ListingButton>
		<MyTable :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete" @Currentchange="contractlistcontractlist"
			style="margin: 1rem;"></MyTable>
		<MyDialog :item="EditValue" :DialogTitle="DialogTitle" @changedia="changedia"
			:centerDialogVisible="centerDialogVisible"></MyDialog>
		<Mycell :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete" @Currentchange="contractlistcontractlist"
			style="padding-bottom: 4rem;"></Mycell>
	</div>
</template>

<script>
	import ListingButton from "@/components/Listing_Button/index.vue"
	import MyTable from "@/components/MyTable/index.vue"
	import MyDialog from "@/components/My_dialog/index.vue"
	import Mycell from "@/components/My_cell/index.vue"
	import {
		contract_reletList,
		contract_reletDelete
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: 'renew',
				lists: [{
					name: '创建',
					type: 'primary',
					icon: 'el-icon-plus',
					funt: 'add'
				}, {
					name: '删除',
					type: 'danger',
					icon: 'el-icon-delete',
					funt: 'delete'
				}],
				tableData: [],
				table_label: [{
					label: 'ID',
					value: 'id'
				}, {
					label: '姓名',
					value: 'name'
				}, {
					label: '手机号',
					value: 'phone'
				}, {
					label: '房间编号',
					value: 'room_num'
				}, {
					label: '类型',
					value: 'type'
				}, {
					label: '申请时间',
					value: 'create_time'
				}, {
					label: '到期时间',
					value: 'end_time'
				}, {
					label: '续租时间',
					value: 'relet_time'
				}, {
					label: '备注',
					value: 'remark'
				}, {
					label: '状态',
					value: 'status'
				}],
				total: null,
				multipleSelection: [],
				EditValue: '',
				centerDialogVisible: false,
				DialogTitle: '',
				data: {
					page: 1,
					limit: 15
				}
			}
		},
		methods: {
			contractlistcontractlist(value) {
				this.data.page = value ? value : this.data.page
				contract_reletList(this.data).then(res => {
					console.log('res', res);
					if (res.status == 200) {
						this.tableData = res.data.list
						this.total = res.data.count
						if (res.__requestPayload) {
							this.data = res.__requestPayload
						}
					}
				})
			},
			add() {
				this.centerDialogVisible = true
				this.DialogTitle = '创建续租'
			},
			//点击编辑
			Edit(value) {
				console.log('Edit', value);
				this.EditValue = value
				this.centerDialogVisible = true
				this.DialogTitle = '续租审核'
			},
			// 批量删除的数组
			DeleteValue(value) {
				this.multipleSelection = value
			},
			// 批量删除的方法
			BatchDelete() {
				contract_reletDelete({
					ids: this.multipleSelection
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
				console.log(111);
			},
			// 点击删除
			Delete(value) {
				console.log("Delete", value.id);
				contract_reletDelete({
					ids: [`${value.id}`]
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			changedia(value) {
				this.centerDialogVisible = value
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			}
		},
		components: {
			MyTable,
			ListingButton,
			MyDialog,
			Mycell
		},
		created() {
			this.contractlistcontractlist()
		},
	}
</script>

<style scoped>

</style>